module.exports = __webpack_public_path__ + "img/ics_f_close_circle.e0a58b55.svg";